<template>
    <div>
        <zm-row v-if="!isCollection">
            <zm-button size="small" @click="showCreateTopic()" class="btn-in-line" type="primary" v-if="role === 'SUPER_ADMIN'">create topic</zm-button>
            <zm-dropdown class="btn-contain" style="margin-right: 8px;" @command="handleBatchCommand" v-if="hasPermission">
                <zm-button size="small" type="primary" plain class="btn-contain" :loading="batchLoading">batch operation</zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="import" v-if="role === 'SUPER_ADMIN'">import topics</zm-dropdown-item>
                    <zm-dropdown-item command="batch" v-if="role === 'SUPER_ADMIN'">batch create topics</zm-dropdown-item>
                    <zm-dropdown-item command="showSelect" v-if="!showSelect">batch edit privileges</zm-dropdown-item>
                    <zm-dropdown-item command="showSelect" v-if="!showSelect">batch delete topics</zm-dropdown-item>
                    <zm-dropdown-item command="showSelect" v-if="!showSelect">batch migrate topics</zm-dropdown-item>
                    <zm-dropdown-item command="showBatchEditPrivilege" v-if="showSelect && ids.length">
                        batch edit privileges
                    </zm-dropdown-item>
                    <zm-dropdown-item command="batchDelete" v-if="showSelect && ids.length">
                        batch delete topics
                    </zm-dropdown-item>
                    <zm-dropdown-item command="batchMigrate" v-if="showSelect && ids.length">
                        batch migrate topics
                    </zm-dropdown-item>
                    <zm-dropdown-item command="hideSelect" v-if="showSelect">
                        cancel batch operation
                    </zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <!-- <zm-dropdown split-button type="primary" @click="showCreateTopic" @command="handleCreateCommand">
                create topic
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="batch">batch create topics</zm-dropdown-item>
                    <zm-dropdown-item command="showBatchEditPrivilege">update old topics failedRate</zm-dropdown-item>
                    <zm-dropdown-item command="batchDelete">update topics min in sync replica</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown> -->
            <zm-button size="small" @click="showAll()" plain>show all topics</zm-button>
            <zm-button size="small" @click="showInternal()" plain v-if="role !== 'APP'">show internal topics</zm-button>
            <zm-dropdown class="btn-contain" style="margin-left: 8px;" @command="handleOPCommand" v-if="hasPermission">
                <zm-button size="small" type="danger" plain class="btn-contain" :loading="cleanLoading">topic op command</zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="cleanInternalTopic">
                        clean internal topics
                    </zm-dropdown-item>
                    <zm-dropdown-item command="updateOldTopicsFailedRate">
                        update old topics failedRate
                    </zm-dropdown-item>
                    <zm-dropdown-item command="updateTopicsMinInSyncReplica">
                        update topics min in sync replica
                    </zm-dropdown-item>
                    <zm-dropdown-item command="updateOldTopicsProducerClientParam">
                        update old topics producer clientParam
                    </zm-dropdown-item>
                    <zm-dropdown-item command="updateOldTopicsRetention">
                        update old topics retention
                    </zm-dropdown-item>
                    <zm-dropdown-item command="showUpdateTopicForOldSubscribers">
                        update topic for old subscribers
                    </zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <zm-button size="small" plain @click="downloadTopics" style="margin-left: 8px;" v-if="hasPermission">download all</zm-button>
            <zm-input size="small" placeholder="search" v-model.trim="search" class="search-input" @keyup.enter.native="doSearch()" v-if="select !== 'channel' && select !== 'subscriber'">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="doSearch()"></zm-button>
            </zm-input>
            <zm-button size="small" icon="zm-icon-search" style="float:right;margin:10px;" @click="doSearch()" v-if="select === 'subscriber'"></zm-button>
            <zm-input-number size="small" v-model="search" class="search-input" v-if="select === 'subscriber'" :min="0"></zm-input-number>
            <zm-select size="small" v-model="search" class="channel-select" @change="doSearch()"
                clearable filterable v-if="select === 'channel'" :loading="channelListLoading">
                <zm-option v-for="item in channelList" :key="item.channelId" :label="item.channelName"
                    :value="item.channelId"></zm-option>
            </zm-select>
            <zm-select size="small" v-model="select" class="search-select" @change="changeSearchType">
                <zm-option option-id="1" label="name" value="name"></zm-option>
                <zm-option option-id="2" label="id" value="id"></zm-option>
                <zm-option option-id="3" label="channel" value="channel"></zm-option>
                <zm-option option-id="4" label="subscribersCount" value="subscriber"></zm-option>
            </zm-select>
            <zm-upload
                v-show="false"
                :action="getAction()"
                id="upload"
                ref="upload"
                :file-list="fileList"
                :headers="headers"
                :on-success="onSuccess"
                :on-error="onError"
                :on-progress="onProgress"
                >
            </zm-upload>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border @sort-change="onSort" @selection-change="handleSelectionChange"
                :data="listBy&&listInternal ? searchList:list" v-loading="loading" @expand-change="showInfo"
                :row-class-name="tableRowClassName">
                <zm-table-column v-if="showSelect && !isCollection" prop="selection" type="selection" width="55"></zm-table-column>
                <zm-table-column type="expand">
                    <template slot-scope='scope'>
                        <topic-detail :topicId="scope.row.id" :topicName="scope.row.name"></topic-detail>
                    </template>
                </zm-table-column>
                <zm-table-column prop="name" label="name" align="left" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="groupName" label="groupName" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="ack" label="ack" width="70px" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.ack,'zm-icon-close':!scope.row.ack}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="timeout" width="78px" label="timeout" align="center">
                </zm-table-column>
                <zm-table-column prop="timeoutIsSuccess" width="147px" label="timeoutIsSuccess" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.timeoutIsSuccess,'zm-icon-close':!scope.row.timeoutIsSuccess}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="createdTime" width="210px" label="createdTime" align="center" :formatter="setTime" sortable>
                </zm-table-column>
                <zm-table-column label="operate" width="150px" header-align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.name !== scope.row.url">
                            <zm-button size="small" class="btn-contain" type="icon" title="edit topic" icon="zm-icon-edit"
                            @click="showEditTopic(scope.row)"></zm-button>
                            <zm-button size="small" class="btn-contain" type="icon" title="enable topic" icon="zm-icon-play"
                            v-if="!scope.row.active" @click="activeTopic(scope.row)" :disabled="scope.row.operateTopicStatus !== 'STABLE'"></zm-button>
                            <zm-button size="small" class="btn-contain" type="icon" title="disable topic" icon="zm-icon-pause"
                            v-if="scope.row.active" @click="activeTopic(scope.row)" :disabled="scope.row.operateTopicStatus !== 'STABLE'"></zm-button>
                            <zm-dropdown class="btn-contain" style="margin-left: 10px;" @command="handleCommand">
                                <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                                <zm-dropdown-menu slot="dropdown">
                                    <zm-dropdown-item :command="{command: 'showPrivileges', param: scope.row.id}">
                                        Edit Privileges
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'showDuplicateTopic', param: scope.row}" v-if="scope.row.operateTopicStatus === 'STABLE' && !isCollection">
                                        Duplicate Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'restartTopic', param: scope.row}">
                                        Restart Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'deleteTopic', param: scope.row}"
                                    v-if="!scope.row.active && scope.row.operateTopicStatus === 'STABLE'">
                                        Delete Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'dropTopic', param: scope.row.id}"
                                    v-if="!scope.row.active && scope.row.operateTopicStatus === 'STABLE'">
                                        Drop Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item
                                        :command="{command: 'showMonitor', param: scope.row.name}">
                                        Show Monitor
                                    </zm-dropdown-item>
                                    <zm-dropdown-item
                                        v-if="scope.row.operateTopicStatus === 'STABLE'"
                                        :command="{command: 'showMigrate', param: scope.row}">
                                        Migrate Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item
                                        v-if="hasPermission"
                                        :command="{command: 'showCreateSub', param: scope.row}">
                                        Add Subscription
                                    </zm-dropdown-item>
                                </zm-dropdown-menu>
                            </zm-dropdown>
                        </div>
                        <div v-else>
                            <zm-button size="small" class="btn-contain" type="icon" title="edit topic" icon="zm-icon-edit"
                            @click="showEditTopic(scope.row)" v-if="hasPermission"></zm-button>
                            <zm-button size="small" class="btn-contain" type="icon" title="show subscribers" icon="zm-icon-eyes"
                            @click="showSubscriber(scope.row.id)"></zm-button>
                            <zm-dropdown class="btn-contain" style="margin-left: 10px;" trigger="click" @command="handleCommand">
                                <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                                <zm-dropdown-menu slot="dropdown">
                                    <zm-dropdown-item :command="{command: 'deleteTopic', param: scope.row}"
                                    v-if="(hasPermission) && scope.row.operateTopicStatus === 'STABLE'">
                                        Delete Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'dropTopic', param: scope.row.id}"
                                    v-if="(hasPermission) && scope.row.operateTopicStatus === 'STABLE'">
                                        Drop Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item
                                        :command="{command: 'showMonitor', param: scope.row.name}">
                                        Show Monitor
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'showMigrate', param: scope.row}"
                                    v-if="(hasPermission) && scope.row.operateTopicStatus === 'STABLE'">
                                        Migrate Topic
                                    </zm-dropdown-item>
                                    <zm-dropdown-item
                                        v-if="hasPermission"
                                        :command="{command: 'showCreateSub', param: scope.row}">
                                        Add Subscription
                                    </zm-dropdown-item>
                                </zm-dropdown-menu>
                            </zm-dropdown>
                        </div>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap" v-if="!isCollection">
                <zm-pagination @current-change="paginationChange"
                    v-if="!listInternal"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" :show-close="true" width="650px" class="short-dialog">
            <zm-form :model="form" label-position="left" :rules="rules" ref="form" style="width: 95%;" :label-width="formLabelWidth">
                <zm-form-item label="name" prop="name">
                    <div slot="label">
                        <tip label="name" id="topic-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name" :disabled="form.superEdit" @keyup.native="trimLR"></zm-input>
                </zm-form-item>
                <zm-form-item label="owner" prop="owner">
                    <div slot="label">
                        <tip label="owner" id="topic-owner"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.owner" :disabled="form.superEdit"></zm-input>
                </zm-form-item>
                <zm-form-item label="description" prop="description">
                    <div slot="label">
                        <tip label="description" id="topic-description"></tip>
                    </div>
                    <zm-input size="small" v-model="form.description" type="textarea"
                        :autosize="{ minRows: 1, maxRows: 4}" :disabled="form.superEdit"></zm-input>
                </zm-form-item>
                <zm-form-item label="channels">
                    <div slot="label">
                        <tip label="channels" id="topic-channel"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.channels" :min="form.minchannel"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="replicaFactor">
                    <div slot="label">
                        <tip label="replicaFactor" id="topic-replicaFactor"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.factor" :min="1" :disabled="form.title === 'Edit Topic'"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.broadcast" :disabled="form.title === 'Edit Topic'" @change="fetchGroups">
                        <tip label="broadcast" id="topic-broadcast"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="dc" v-if="form.title !== 'Edit Topic' && !form.broadcast" prop="dcName">
                    <div slot="label">
                        <tip label="dc" id="topic-dc"></tip>
                    </div>
                    <zm-select size="small" v-model="form.dcName" @change="onChangeDc" clearable>
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="groupName"
                    v-if="form.title !== 'Edit Topic' && ((form.dcName && !form.broadcast) || form.broadcast)">
                    <div slot="label">
                        <tip label="groupName" id="topic-groupName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.groupName" clearable>
                        <zm-option v-for="item in groups" :key="item.groupName" :value="item.groupName" :label="item.groupName + '(currentLoad: ' + item.currentLoad + ')'"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="jobStore"
                    v-if="form.title !== 'Edit Topic' && ((form.dcName && !form.broadcast) || form.broadcast)">
                    <div slot="label">
                        <tip label="jobStore" id="topic-jobStore"></tip>
                    </div>
                    <zm-select size="small" v-model="form.jobStore" clearable>
                        <zm-option v-for="item in jobStores" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="jobStore"
                    v-if="form.title === 'Edit Topic'">
                    <div slot="label">
                        <tip label="jobStore" id="topic-jobStore"></tip>
                    </div>
                    <zm-select size="small" v-model="form.jobStore" clearable>
                        <zm-option v-for="item in jobStoreAll" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="groupName" v-if="form.title === 'Edit Topic'">
                    <div slot="label">
                        <tip label="groupName" id="topic-cluster"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.groupName" v-if="form.title === 'Edit Topic'" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.ordered" :disabled="form.title === 'Edit Topic'">
                        <tip label="ordered" id="topic-ordered"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="threshold">
                    <div slot="label">
                        <tip label="threshold" id="topic-threshold"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.threshold" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="failedRate">
                    <div slot="label">
                        <tip label="failedRate" id="topic-failedRate"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.failedRate" :disabled="form.superEdit"
                            :min="0" :max="100" class="number-with-select"></zm-input-number>
                        <zm-tag type="info" class="tag-with-number">%</zm-tag>
                    </div>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.ack" :disabled="form.superEdit"><tip label="ack" id="topic-ack"></tip></zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.timeoutIsSuccess" :disabled="form.superEdit">
                        <tip label="timeoutIsSuccess" id="topic-timeoutIsSuccess"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-collapse v-model="showAdvancedFeatureMap">
                    <zm-collapse-item title="additional parameters" name="2">
                <zm-form-item label="timeout">
                    <div slot="label">
                        <tip label="timeout" id="topic-timeout"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.timeout" :disabled="form.superEdit" :min="0" class="number-with-select"></zm-input-number>
                        <zm-tag type="info" class="tag-with-number">MINUTES</zm-tag>
                    </div>
                </zm-form-item>
                <zm-form-item label="version">
                    <div slot="label">
                        <tip label="version" id="topic-version"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.version" :min="0" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableMetrics" :disabled="form.superEdit">
                        <tip label="enable metrics" id="topic-enableMetrics"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="ttlDuration">
                    <div slot="label">
                        <tip label="ttlDuration" id="topic-ttlDuration"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.ttlDuration" :disabled="form.superEdit" :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="form.ttlDurationTimeUnit" class="select-with-number" :disabled="form.superEdit">
                                <zm-option value="SECONDS">SECONDS</zm-option>
                                <zm-option value="MINUTES">MINUTES</zm-option>
                                <zm-option value="HOURS">HOURS</zm-option>
                                <zm-option value="DAYS">DAYS</zm-option>
                            </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label="clientMapRetentionDay" label-width="200px">
                    <div slot="label">
                        <tip label="clientMapRetentionDay" id="topic-clientMapRetentionDay"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.clientMapRetentionDay" :min="0" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="pollDurationMs" label-width="200px">
                    <div slot="label">
                        <tip label="pollDurationMs" id="topic-pollDurationMs"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.pollDurationMs" :min="1" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.publishIsPublic" :disabled="form.superEdit">
                        <tip label="publish is public" id="topic-publishIsPublic"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.subscribeIsPublic" :disabled="form.superEdit">
                        <tip label="subscribe is public" id="topic-subscribeIsPublic"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.discardUnhandledTask" :disabled="form.superEdit">
                        <tip label="discardUnhandledTask" id="topic-discardUnhandledTask"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.disableFailover" :disabled="form.superEdit">
                        <tip label="disableFailover" id="topic-disableFailover"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="maxProduceRetryTimes" label-width="200px">
                    <div slot="label">
                        <tip label="maxProduceRetryTimes" id="topic-maxProduceRetryTimes"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.maxProduceRetryTimes" :min="0" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="produceRetryInterval" label-width="200px">
                    <div slot="label">
                        <tip label="produceRetryInterval" id="topic-produceRetryInterval"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.produceRetryInterval" :disabled="form.superEdit"
                            :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="form.produceRetryIntervalTimeUnit" class="select-with-number" :disabled="form.superEdit">
                            <zm-option value="SECONDS">SECONDS</zm-option>
                            <zm-option value="MINUTES">MINUTES</zm-option>
                            <zm-option value="HOURS">HOURS</zm-option>
                            <zm-option value="DAYS">DAYS</zm-option>
                        </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label="produceLimit">
                    <div slot="label">
                        <tip label="produceLimit" id="topic-produceLimit"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.produceLimit" :min="0" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="produceJobLimit">
                    <div slot="label">
                        <tip label="produceJobLimit" id="topic-produceJobLimit"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.produceJobLimit" :min="0" :disabled="form.superEdit"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="producerClientParam" label-width="200px">
                    <div slot="label">
                        <tip label="producerClientParam" id="topic-producerClientParam"></tip>
                    </div>
                    <zm-select size="small" v-model="form.producerClientParamId" :disabled="form.superEdit" clearable filterable>
                        <zm-option v-for="item in producerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="maxRetryTimes">
                    <div slot="label">
                        <tip label="maxRetryTimes" id="topic-maxRetryTimes"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.maxRetryTimes" :disabled="form.superEdit" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="retryInterval">
                    <div slot="label">
                        <tip label="retryInterval" id="topic-retryInterval"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.retryInterval" :disabled="form.superEdit"
                            :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="form.retryIntervalTimeUnit"
                            class="select-with-number" :disabled="form.superEdit">
                            <zm-option value="SECONDS">SECONDS</zm-option>
                            <zm-option value="MINUTES">MINUTES</zm-option>
                            <zm-option value="HOURS">HOURS</zm-option>
                            <zm-option value="DAYS">DAYS</zm-option>
                        </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label="consumerClientParam" label-width="200px">
                    <div slot="label">
                        <tip label="consumerClientParam" id="topic-consumerClientParam"></tip>
                    </div>
                    <zm-select size="small" v-model="form.consumerClientParamId" :disabled="form.superEdit" clearable filterable>
                        <zm-option v-for="item in consumerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                    </zm-collapse-item>
                    <zm-collapse-item title="advanced features" name="1">
                    <div v-for="item in advancedFeatureMap" :key="item.display">
                        <zm-form-item label-width="175px">
                            <template slot="label">
                                <tip :label="item.display" :tips="item.description"></tip>
                            </template>
                            <zm-radio-group v-model="item.currentValue" v-if="item.frontEndType === 2">
                                <zm-radio v-for="radio in item.suggestedValues" :key="radio" :label="radio">{{ radio }}</zm-radio>
                            </zm-radio-group>
                            <zm-input-number size="small" v-model="item.currentValue" :min="1"
                                v-if="item.frontEndType === 1 && item.display !== 'minInSyncRelicas'"></zm-input-number>
                            <zm-input-number size="small" v-model="item.currentValue" :min="1" :max="form.factor"
                                v-if="item.frontEndType === 1 && item.display === 'minInSyncRelicas'"></zm-input-number>
                            <zm-select size="small" v-model="item.currentValue" v-if="item.frontEndType === 0">
                                <zm-option v-for="radio in item.suggestedValues" :key="radio" :value="radio">{{ radio }}</zm-option>
                            </zm-select>
                        </zm-form-item>
                    </div>
                    </zm-collapse-item>
                </zm-collapse>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Edit Privileges" :visible.sync="privilegesVisible" width="80%">
            <zm-row>
                <zm-col :span="8">
                    <b>publishers</b>
                    <div class="user-list">
                    <zm-checkbox-group vertical v-model="editPrivileges.publisherUserIds">
                        <zm-checkbox v-for="item in publishers" :key="item.id" :label="item.id"
                        :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
                    </zm-checkbox-group>
                    </div>
                </zm-col>
                <zm-col :span="8">
                    <zm-input size="small" type="text" class="search-app-input" placeholder="search app" v-model.trim="editPrivileges.search"></zm-input>
                    <div class="app-list">
                        <div v-for="item in apps" :key="item.id" class="user-privilege" :class="item.active?'active-user':'inactive-user'">
                            <zm-button type="icon" class="zm-icon-left" style="float: left" @click="appendPub(item.id)"
                                :disabled="editPrivileges.publisherUserIds.indexOf(item.id) !== -1"></zm-button>
                            <span>{{ item.name }}</span>
                            <zm-button type="icon" class="zm-icon-right" style="float: right" @click="appendSub(item.id)"
                                :disabled="editPrivileges.subscriberUserIds.indexOf(item.id) !== -1"></zm-button>
                        </div>
                    </div>
                </zm-col>
                <zm-col :span="8">
                    <b>subscribers</b>
                    <div class="user-list">
                    <zm-checkbox-group vertical v-model="editPrivileges.subscriberUserIds">
                        <zm-checkbox v-for="item in subscribers" :key="item.id" :label="item.id"
                        :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
                    </zm-checkbox-group>
                    </div>
                </zm-col>
            </zm-row>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="privilegesVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="savePrivileges()" :loading="loading || batchLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Topic Remain" :visible.sync="remainVisible" :show-close="true">
            <zm-table :data="remainData">
                <zm-table-column prop="mqType" width="105px" label="mqType" align="center" :show-overflow-tooltip="true"></zm-table-column>
                <zm-table-column prop="group" label="group" align="center" :show-overflow-tooltip="true"></zm-table-column>
                <zm-table-column prop="remain" width="105px" label="remain" align="center"></zm-table-column>
                <zm-table-column prop="url" label="url" align="center" :show-overflow-tooltip="true"></zm-table-column>
            </zm-table>
        </zm-dialog>
        <zm-dialog title="Clean Result" :visible.sync="showCleanResult" :show-close="true">
            <zm-table :data="cleanResult">
                <zm-table-column prop="name" label="topicName"></zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="showCleanResult = false">Close</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :title="migrateForm.oldGroupName ? 'Migrate Topic' : 'Migrate Topics'" :visible.sync="migrateVisible" :show-close="true">
            <zm-form label-width="180px" label-position="left">
                <zm-form-item label="old dcName" v-if="migrateForm.oldDcName">
                    <div slot="label">
                        <tip label="old dcName" id="topic-migrate-oldDcName"></tip>
                    </div>
                    <zm-input size="small" v-model="migrateForm.oldDcName" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label="old groupName" v-if="migrateForm.oldGroupName">
                    <div slot="label">
                        <tip label="old groupName" id="topic-migrate-oldGroupName"></tip>
                    </div>
                    <zm-input size="small" v-model="migrateForm.oldGroupName" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label="new dcName">
                    <div slot="label">
                        <tip label="new dcName" id="topic-migrate-dcName"></tip>
                    </div>
                    <zm-select size="small" v-model="migrateForm.dcName" @change="onChangeDcForMigrate" style="width:100%"  filterable clearable>
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="new groupName">
                    <div slot="label">
                        <tip label="new groupName" id="topic-migrate-groupName"></tip>
                    </div>
                    <zm-select size="small" v-model="migrateForm.groupName" style="width:100%" filterable clearable>
                        <zm-option v-for="item in groups" :key="item.groupName" :value="item.groupName" :label="item.groupName + '(currentLoad: ' + item.currentLoad + ')'"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="migrateForm.forceMigrate">
                        <tip label="forceMigrate" id="topic-migrate-forceMigrate"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="subscriberRatioForOld">
                    <div slot="label">
                        <tip label="subscriberRatioForOld" id="topic-migrate-subscriberRatioForOld"></tip>
                    </div>
                    <zm-input-number size="small" v-model="migrateForm.subscriberRatioForOld" :min="10" :max="100" :step="10">
                    </zm-input-number>
                </zm-form-item>
                <zm-form-item label="retainDataDays">
                    <div slot="label">
                        <tip label="retainDataDays" id="topic-migrate-retainDataDays"></tip>
                    </div>
                    <zm-input-number size="small" v-model="migrateForm.retainDataDays" :min="0" :max="7" :step="1">
                    </zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="migrateVisible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="doMigrate" :loading="migrateForm.loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Add Subscription" :visible.sync="subVisible" :show-close="true">
            <zm-form label-width="200px" label-position="left" ref="subForm" :rules="subRules" :model="subForm">
                <zm-form-item label="dcName" prop="dcName">
                    <div slot="label">
                        <tip label="dcName" id="topic-addsub-dcName"></tip>
                    </div>
                    <zm-select size="small" v-model="subForm.dcName" clearable style="width:100%">
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="group" prop="group">
                    <div slot="label">
                        <tip label="group" id="topic-addsub-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="subForm.group"></zm-input>
                </zm-form-item>
                <zm-form-item label="minWorkingCount">
                    <div slot="label">
                        <tip label="minWorkingCount" id="topic-addsub-minWorkingCount"></tip>
                    </div>
                    <zm-input-number size="small" v-model="subForm.minWorkingCount" :min="0" style="width:100%"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="settingConsumeDelayMs">
                    <template slot="label">
                        <tip label="settingConsumeDelayMs" id="topic-addsub-settingConsumeDelayMs"></tip>
                    </template>
                    <zm-input-number size="small" v-model="subForm.settingConsumeDelayMs" :min="-1" style="width:100%"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="threshold">
                    <template slot="label">
                        <tip label="threshold" id="topic-addsub-threshold"></tip>
                    </template>
                    <zm-input-number size="small" v-model="subForm.threshold" :min="0" style="width:100%"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="subForm.createRealGroup">
                        <tip label="createRealGroup" id="topic-addsub-createRealGroup"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="shakeType" prop="shakeType" label-width="150px">
                    <div slot="label">
                        <tip label="shakeType" id="topic-addsub-shakeType"></tip>
                    </div>
                    <zm-radio-group size="small" v-model="subForm.shakeType" :disabled="subFormOrdered">
                        <zm-radio label="ForceShake"></zm-radio>
                        <zm-radio label="NoShake"></zm-radio>
                        <zm-radio label="AutoShake"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="shakeValidPeriodMs" prop="shakeValidPeriodMs" label-width="200px">
                    <div slot="label">
                        <tip label="shakeValidPeriodMs" id="topic-addsub-shakeValidPeriodMs"></tip>
                    </div>
                    <zm-input-number size="small" v-model="subForm.shakeValidPeriodMs" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="consumerClientParamId" prop="consumerClientParamId" label-width="200px">
                    <div slot="label">
                        <tip label="consumerClientParamId" id="topic-addsub-consumerClientParamId"></tip>
                    </div>
                    <zm-select size="small" v-model="subForm.consumerClientParamId" clearable filterable>
                        <zm-option v-for="item in consumerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="subForm.discardUnhandledTask">
                        <tip label="discardUnhandledTask" id="topic-addsub-discardUnhandledTask"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="timeout" prop="timeout" label-width="140px">
                    <div slot="label">
                        <tip label="timeout" id="topic-addsub-timeout"></tip>
                    </div>
                    <zm-input-number size="small" v-model="subForm.timeout" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="subForm.timeoutIsSuccess">
                        <tip label="timeoutIsSuccess" id="topic-addsub-timeoutIsSuccess"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="maxRetryTimes" prop="maxRetryTimes" label-width="140px">
                    <div slot="label">
                        <tip label="maxRetryTimes" id="topic-addsub-maxRetryTimes"></tip>
                    </div>
                    <zm-input-number size="small" v-model="subForm.maxRetryTimes" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="retryInterval" label-width="140px">
                    <div slot="label">
                        <tip label="retryInterval" id="topic-addsub-retryInterval"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="subForm.retryInterval"
                            :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="subForm.retryIntervalTimeUnit"
                            class="select-with-number">
                            <zm-option value="SECONDS">SECONDS</zm-option>
                            <zm-option value="MINUTES">MINUTES</zm-option>
                            <zm-option value="HOURS">HOURS</zm-option>
                            <zm-option value="DAYS">DAYS</zm-option>
                        </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label="version" label-width="140px">
                    <div slot="label">
                        <tip label="version" id="topic-addsub-version"></tip>
                    </div>
                    <zm-input-number size="small" v-model="subForm.version" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="subVisible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="doCreateSub" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Update Topics Min In Sync Replica" :visible.sync="minInSyncForm.visible" :show-close="true">
            <zm-form label-width="190px" label-position="left">
                <zm-form-item label="channelId" prop="channelId">
                    <template slot="label">
                        <tip label="channelId" id="topic-minInSync-channelId"></tip>
                    </template>
                    <zm-select size="small" v-model="minInSyncForm.channelId" clearable filterable style="width:100%">
                        <zm-option v-for="item in channelList" :key="item.channelId" :label="item.channelName" :value="item.channelId"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="type" prop="type">
                    <template slot="label">
                        <tip label="type" id="topic-minInSync-type"></tip>
                    </template>
                    <zm-radio-group size="small" v-model="minInSyncForm.type">
                        <zm-radio label="num"></zm-radio>
                        <zm-radio label="rate"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="minInSync">
                    <template slot="label">
                        <tip label="minInSync" id="topic-minInSync-minInSync"></tip>
                    </template>
                    <zm-input-number size="small" v-model="minInSyncForm.minInSyncReplicaNum" :min="0" v-if="minInSyncForm.type === 'num'"></zm-input-number>
                    <zm-input-number size="small" v-model="minInSyncForm.minInSyncReplicaRate" :min="0" :max="100" v-if="minInSyncForm.type === 'rate'"></zm-input-number>
                    <span v-if="minInSyncForm.type === 'rate'">%</span>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="minInSyncForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="updateTopicsMinInSyncReplica" :loading="minInSyncForm.loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <batch-create ref="batchCreate" @refreshTopic="paginationChange"></batch-create>
        <zm-dialog title="Update Topic For Old Subscribers" :visible.sync="updateTopicForOldSubscribersForm.visible">
            <zm-form label-width="120px">
                <zm-form-item>
                    <template slot="label">
                        <tip label="execute" id="topic-updateTopicForOldSubscribers-execute"></tip>
                    </template>
                    <zm-input v-model="updateTopicForOldSubscribersForm.execute"></zm-input>
                </zm-form-item>
                <zm-form-item>
                    <template slot="label">
                        <tip label="toTime" id="topic-updateTopicForOldSubscribers-toTime"></tip>
                    </template>
                    <zm-date-picker v-model="updateTopicForOldSubscribersForm.toTime"
                        type="datetime" value-format="timestamp"></zm-date-picker>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="updateTopicForOldSubscribersForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="updateTopicForOldSubscribers" :loading="cleanLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Long Task" :visible.sync="showId">
            <span>Long task id is: &nbsp;</span>
            <input id="textCopy1" v-show="true" class="zm-input__inner secret-input" readonly/>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="showId = false">OK</zm-button>
                <button type="button" id="copybutton2" class="zm-button zm-button--primary"
                    ref="copy1"
                    @click="handleCopy1"
                    data-clipboard-action="copy"
                    data-clipboard-target="#textCopy1"
                    v-show="true">Copy and Close</button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getDedicatedJob, getDedicatedJobByDc } from '@/api/job'
import { listClient } from '../../api/clientparam'
import { getTopicList, createTopic, updateTopic, deleteTopic, getTopicListByNamelike, activeTopic,
getTopicConfig, getTopicPrivileges, updateTopicPrivileges, duplicateTopic, getTopicRemain,
dropTopic, getTopicById,
getTopicByChannel, getChannels,
getActiveGroups,
getChannelDcs,
cleanInternalTopic,
updateOldTopicsRetention,
updateOldTopicsProducerClientParam,
migrateTopic,
getTopicListBySubscribersCount,
updateOldTopicsFailedRate,
createSubscriber,
updateTopicsMinInSyncReplica,
batchDelete,
batchUpdateTopicPrivileges,
downloadTopics,
updateTopicForOldSubscribers,
getActiveChannels, getUsers, getInternalTopicList, getChannelById } from '../../api/index'
import topicDetail from './topicDetail'
import tip from 'components/ToolTip/index'
import batchCreate from './batchCreate'
import { getTopicByNames } from '@/api/collection'
import Clipboard from 'clipboard'
export default {
    name: 'topic',
    components: {
        batchCreate,
        tip,
        topicDetail
    },
    props: ['topicNames', 'isCollection'],
    data () {
        var validateGroup = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter group'))
            } else {
                var reg = /^[^\s]*$/
                if (reg.test(value)) {
                    callback()
                }
                callback(new Error('invalid group!'))
            }
        }
        return {
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            showSelect: false,
            batchLoading: false,
            list: [],
            searchList: [],
            listBy: 0,
            listInternal: false,
            loading: false,
            checkInfo: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            select: 'name',
            channelList: [],
            channelListLoading: false,
            search: '',
            dialogFormVisible: false,
            remainVisible: false,
            remainData: [],
            channels: [],
            dcs: [],
            groups: [],
            jobStores: [],
            jobStoreAll: [],
            producerClient: [],
            consumerClient: [],
            form: {
                title: '',
                id: '',
                clusterGroup: '',
                name: '',
                owner: '',
                version: '',
                restartVersion: '',
                clientMapRetentionDay: '',
                channels: '',
                factor: 1,
                broadcast: false,
                dcName: '',
                groupName: '',
                jobStore: null,
                channelId: '',
                discardUnhandledTask: false,
                disableFailover: false,
                maxProduceRetryTimes: 3,
                produceRetryInterval: 1,
                produceRetryIntervalTimeUnit: 'MINUTES',
                produceLimit: '0',
                produceJobLimit: '0',
                ack: false,
                threshold: '',
                pollDurationMs: 5000,
                publishIsPublic: false,
                subscribeIsPublic: false,
                maxRetryTimes: '',
                retryIntervalTimeUnit: '',
                retryInterval: '',
                ttlDuration: '',
                ttlDurationTimeUnit: '',
                timeout: '',
                timeoutIsSuccess: false,
                description: '',
                minchannel: 1,
                minRestartVersion: 1,
                failedRate: 0,
                ordered: false,
                consumerClientParamId: '',
                producerClientParamId: '',
                enableMetrics: true,
                superEdit: false
            },
            showAdvancedFeatureMap: [],
            advancedFeatureMap: {},
            topicFactor: Number,
            formLabelWidth: '150px',
            privilegesVisible: false,
            editPrivileges: {
                topicId: '',
                publisherUserIds: [],
                subscriberUserIds: [],
                search: '',
                // searchSubscribers: '',
                users: []
            },
            ids: [],
            cleanLoading: false,
            cleanResult: [],
            showCleanResult: false,
            migrateVisible: false,
            migrateForm: {
                loading: false,
                isInternal: false,
                isBroadcast: false,
                oldDcName: '',
                oldGroupName: '',
                dcName: '',
                groupName: '',
                forceMigrate: false,
                subscriberRatioForOld: 20,
                retainDataDays: 7,
                topicIds: []
            },
            subVisible: false,
            subFormOrdered: false,
            subForm: {
                createRealGroup: false,
                shakeType: '',
                shakeValidPeriodMs: 0,
                consumerClientParamId: '',
                discardUnhandledTask: false,
                timeout: '',
                timeoutIsSuccess: false,
                maxRetryTimes: '',
                retryInterval: '',
                retryIntervalTimeUnit: 'MINUTES',
                version: '',
                topicId: '',
                dcName: '',
                group: '',
                minWorkingCount: 0,
                settingConsumeDelayMs: -1,
                threshold: 0
            },
            minInSyncForm: {
                visible: false,
                loading: false,
                channelId: '',
                minInSyncReplicaNum: '',
                minInSyncReplicaRate: '',
                type: ''
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                owner: [
                    { required: true, message: 'please enter owner', trigger: 'blur' }
                ],
                dcName: [
                    { required: true, message: 'please select a dc', trigger: 'change' }
                ],
                // channelId: [
                //     { required: true, message: 'please select channel', trigger: 'change' }
                // ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            },
            subRules: {
                group: [
                    { required: true, validator: validateGroup, trigger: 'blur' }
                ]
            },
            updateTopicForOldSubscribersForm: {
                visible: false,
                execute: '',
                toTime: ''
            },
            fileList: [],
            showId: false,
            longTaskId: '',
            headers: {
                Authorization: 'Bearer ' + localStorage.token
            }
        }
    },
    computed: {
        apps () {
            if (this.editPrivileges.search) {
                return this.editPrivileges.users.filter(data => {
                    return String(data.name).toLowerCase().indexOf(this.editPrivileges.search) > -1
                })
            }
            return this.editPrivileges.users
        },
        publishers () {
            if (this.editPrivileges.publisherUserIds.length) {
                return this.editPrivileges.users.filter(data => {
                    return this.editPrivileges.publisherUserIds.indexOf(data.id) > -1
                })
            }
            return []
        },
        subscribers () {
            if (this.editPrivileges.subscriberUserIds.length) {
                return this.editPrivileges.users.filter(data => {
                    return this.editPrivileges.subscriberUserIds.indexOf(data.id) > -1
                })
            }
            return []
        }
    },
    created () {
        // if (this.$route.name === 'Topic') {
        //     this.checkInfo = false
        // } else {
        //     this.checkInfo = true
        // }
        if (this.isCollection) {
            this.fetchData()
        } else if (this.$route.query.id) {
            this.select = 'id'
            this.search = this.$route.query.id
            this.doSearch()
        } else if (this.$route.query.name) {
            this.select = 'name'
            this.search = this.$route.query.name
            this.doSearch()
        } else if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.listBy = JSON.parse(localStorage.params).listBy
            this.select = JSON.parse(localStorage.params).select
            this.search = JSON.parse(localStorage.params).search
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
            if (this.listBy) {
                this.doSearch()
            } else {
                this.fetchData()
            }
        } else {
            this.fetchData()
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchClient()
        this.fetchDcs()
        // this.fetchChannels()
        // this.fetchGroups()
    },
    watch: {
        listBy () {
            this.setURL()
        },
        select () {
            this.setURL()
        },
        search () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { listBy, select, search } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, listBy, select, search, page, size }
            localStorage.params = JSON.stringify(data)
        },
        appendPub (id) {
            this.editPrivileges.publisherUserIds.push(id)
        },
        appendSub (id) {
            this.editPrivileges.subscriberUserIds.push(id)
        },
        trimLR () {
            this.form.name = this.form.name.replace(/\s+/g, '')
        },
        showImport (command) {
            var btn = document.getElementById('upload')
            btn.click()
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            if (this.listBy && this.listInternal) {
                this.searchList.sort((a, b) => {
                    if (a[prop] > b[prop]) {
                        return descending ? -1 : 1
                    } else if (a[prop] < b[prop]) {
                        return descending ? 1 : -1
                    } else {
                        return 0
                    }
                })
            } else {
                this.list.sort((a, b) => {
                    if (a[prop] > b[prop]) {
                        return descending ? -1 : 1
                    } else if (a[prop] < b[prop]) {
                        return descending ? 1 : -1
                    } else {
                        return 0
                    }
                })
            }
        },
        changeSearchType () {
            this.search = ''
            if (this.select === 'channel') {
                this.fetchChannelList()
            }
        },
        fetchClient () {
            listClient('PRODUCER').then(response => {
                this.producerClient = response
            })
            listClient('CONSUMER').then(response => {
                this.consumerClient = response
            })
        },
        fetchData () {
            if (this.isCollection) {
                this.loading = true
                getTopicByNames(this.topicNames).then(response => {
                    if (response) {
                      this.list = response
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
            this.loading = true
            getTopicList(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            }
        },
        fetchChannels () {
            getActiveChannels().then(response => {
                this.channels = response
            })
        },
        fetchChannelList () {
            if (!this.channelList.length) {
                this.channelListLoading = true
                getChannels().then(response => {
                    this.channelListLoading = false
                    this.channelList = response
                }).catch(() => {
                    this.channelListLoading = false
                })
            }
        },
        fetchDcs () {
            this.form.dcName = ''
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        onChangeDc () {
            this.fetchGroups()
            this.getDedicatedJobByDc()
        },
        onChangeDcForMigrate () {
            this.migrateForm.groupName = ''
            getActiveGroups(this.migrateForm.isBroadcast, this.migrateForm.dcName).then(response => {
                this.groups = response
            })
        },
        fetchGroups () {
            this.form.groupName = ''
            var dcName = this.form.broadcast ? '' : this.form.dcName
            getActiveGroups(this.form.broadcast, dcName).then(response => {
                this.groups = response
            })
        },
        getDedicatedJob () {
            getDedicatedJob().then(response => {
                this.jobStoreAll = response
            })
        },
        getDedicatedJobByDc () {
            this.form.jobStore = null
            if (!this.form.broadcast && this.form.dcName) {
                getDedicatedJobByDc(this.form.dcName).then(response => {
                    this.jobStores = response
                })
            }
        },
        showAll () {
            this.listBy = 0
            this.listInternal = false
            this.fetchData()
        },
        showInternal () {
            this.listBy = 0
            this.loading = true
            getInternalTopicList().then(response => {
                this.listInternal = true
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        cleanInternalTopic () {
            this.$confirm('This will clean the internal topics. Continue?', 'Warning', {
                confirmButtonText: 'Clean',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.cleanLoading = true
                cleanInternalTopic().then(response => {
                    this.cleanLoading = false
                    this.cleanResult = response
                    this.showCleanResult = true
                    // this.$message({
                    //     message: 'Clean internal topics success!',
                    //     type: 'success'
                    // })
                }).catch(() => {
                    this.cleanLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Clean canceled'
                })
            })
        },
        updateOldTopicsRetention () {
            this.$confirm('This will update old topics retention. Continue?', 'Warning', {
                confirmButtonText: 'Update',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.cleanLoading = true
                updateOldTopicsRetention().then(response => {
                    this.cleanLoading = false
                    this.$message({
                        message: 'Update old topics retention success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.cleanLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Update canceled'
                })
            })
        },
        showUpdateTopicForOldSubscribers () {
            this.updateTopicForOldSubscribersForm.execute = 'false'
            this.updateTopicForOldSubscribersForm.toTime = ''
            this.updateTopicForOldSubscribersForm.visible = true
        },
        updateTopicForOldSubscribers () {
            const { execute, toTime } = this.updateTopicForOldSubscribersForm
            const data = { execute, toTime }
            this.cleanLoading = true
            updateTopicForOldSubscribers(data).then(response => {
                this.cleanLoading = false
                this.updateTopicForOldSubscribersForm.visible = false
                this.$message({
                    message: 'Update success!',
                    type: 'success'
                })
            }).catch(() => {
                this.cleanLoading = false
            })
        },
        updateOldTopicsProducerClientParam () {
            this.$confirm('This will update old topics producer client param. Continue?', 'Warning', {
                confirmButtonText: 'Update',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.cleanLoading = true
                updateOldTopicsProducerClientParam().then(response => {
                    this.cleanLoading = false
                    this.$message({
                        message: 'Update success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.cleanLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Update canceled'
                })
            })
        },
        showUpdateTopicsMinInSyncReplica () {
            this.fetchChannelList()
            this.minInSyncForm.channelId = ''
            this.minInSyncForm.minInSyncReplicaNum = ''
            this.minInSyncForm.minInSyncReplicaRate = ''
            this.minInSyncForm.type = 'num'
            this.minInSyncForm.visible = true
        },
        updateTopicsMinInSyncReplica () {
            const { channelId, minInSyncReplicaNum, minInSyncReplicaRate, type } = this.minInSyncForm
            var data = {}
            if (type === 'num') {
                data = { channelId, minInSyncReplicaNum }
            } else {
                data = { channelId, minInSyncReplicaRate }
            }
            this.minInSyncForm.loading = true
            updateTopicsMinInSyncReplica(data).then(response => {
                this.minInSyncForm.visible = false
                this.$message.success('Update success')
                this.minInSyncForm.loading = false
            }).catch(() => {
                this.minInSyncForm.loading = false
            })
        },
        updateOldTopicsFailedRate () {
            this.$confirm('This will update old topics failedRate. Continue?', 'Warning', {
                confirmButtonText: 'Update',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.cleanLoading = true
                updateOldTopicsFailedRate({ failedRate: 0 }).then(response => {
                    this.cleanLoading = false
                    this.$message({
                        message: 'Update old topics failedRate success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.cleanLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Update canceled'
                })
            })
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            }
            return ''
        },
        doSearch () {
            if (this.select === 'name') {
                this.searchByName()
            } else if (this.select === 'channel') {
                this.searchByChannel()
            } else if (this.select === 'subscriber') {
                this.searchBySubscribersCount()
            } else {
                this.searchById()
            }
        },
        searchByChannel () {
            if (this.search !== '') {
                this.listBy = 1
                this.loading = true
                getTopicByChannel(this.search).then(response => {
                    this.pageable.total = response.length
                    this.list = response.slice((this.pageable.page - 1) * this.pageable.size, this.pageable.page * this.pageable.size)
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        searchById () {
            if (this.search !== '') {
                this.listBy = 1
                this.loading = true
                getTopicById(this.search).then(response => {
                    this.list = []
                    this.list.push(response)
                    this.pageable.total = 1
                    this.pageable.page = 1
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    message: 'Please input topic id!',
                    type: 'warning'
                })
            }
        },
        searchByName () {
            if (this.search !== '') {
                if (this.listInternal) {
                    this.listBy = 1
                    this.searchList = []
                    this.list.filter(data => {
                        if (String(data['name']).toLowerCase().indexOf(this.search) > -1) {
                            this.searchList.push(data)
                        }
                    })
                } else {
                this.listBy = 1
                this.loading = true
                this.listInternal = false
                getTopicListByNamelike(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, pageable: { page, size }, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
                }
            } else {
                this.$message({
                    message: 'Please input topic name!',
                    type: 'warning'
                })
            }
        },
        searchBySubscribersCount () {
            if (this.search !== '') {
                if (this.listInternal) {
                    this.$message.warning('Cannot list internal topics by subscribers count')
                } else {
                this.listBy = 1
                this.loading = true
                this.listInternal = false
                getTopicListBySubscribersCount(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, pageable: { page, size }, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
                }
            } else {
                this.$message({
                    message: 'Please input subscribers count!',
                    type: 'warning'
                })
            }
        },
        activeTopic (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                activeTopic(row.id, !row.active).then(response => {
                    this.paginationChange()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.paginationChange()
            // if (this.listBy) {
            //     if (this.select === 'name') {
            //         this.searchByName()
            //     } else {
            //         this.searchByChannel()
            //     }
            // } else {
            //     if (this.listInternal) {
            //         this.showInternal()
            //     } else {
            //         this.fetchData()
            //     }
            // }
        },
        paginationChange () {
            if (this.listBy) {
                if (this.select === 'name') {
                    this.searchByName()
                } else if (this.select === 'channel') {
                    this.searchByChannel()
                } else if (this.select === 'subscriber') {
                    this.searchBySubscribersCount()
                } else {
                    this.searchById()
                }
            } else {
                if (this.listInternal) {
                    this.showInternal()
                } else {
                    this.fetchData()
                }
            }
        },
        refreshTopicConfig () {
            for (var item in this.advancedFeatureMap) {
                if (this.advancedFeatureMap[item].frontEndType === 0) {
                    const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                    if ((typeof suggestedValues) === 'string') {
                        this.advancedFeatureMap[item].suggestedValues = suggestedValues.substring(1, suggestedValues.length - 1).split(',')
                    }
                }
                if (this.advancedFeatureMap[item].frontEndType === 2) {
                    const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                    if ((typeof suggestedValues) === 'string') {
                        this.advancedFeatureMap[item].suggestedValues = JSON.parse(suggestedValues)
                    }
                }
            }
        },
        showCreateTopic () {
            getTopicConfig().then(response => {
                this.topicFactor = response.topicFactor
                this.form.factor = response.topicFactor
                this.advancedFeatureMap = response.advancedFeatureMap
                this.refreshTopicConfig()
            })
            // this.fetchChannels()
            this.fetchDcs()
            this.fetchGroups()
            this.form.title = 'Create Topic'
            this.form.name = ''
            this.form.owner = ''
            this.form.version = ''
            this.form.restartVersion = 0
            this.form.clientMapRetentionDay = 7
            this.form.channels = 3
            this.form.dcName = ''
            this.form.groupName = ''
            this.form.jobStore = null
            this.form.channelId = ''
            this.form.discardUnhandledTask = false
            this.form.disableFailover = false
            this.form.maxProduceRetryTimes = '3'
            this.form.produceRetryInterval = '1'
            this.form.produceRetryIntervalTimeUnit = 'MINUTES'
            this.form.produceLimit = '0'
            this.form.produceJobLimit = '0'
            this.form.ack = true
            this.form.broadcast = false
            this.form.threshold = '1000'
            this.form.pollDurationMs = 5000
            this.form.publishIsPublic = false
            this.form.subscribeIsPublic = false
            this.form.enableMetrics = true
            this.form.maxRetryTimes = '3'
            this.form.retryIntervalTimeUnit = 'MINUTES'
            this.form.retryInterval = '1'
            this.form.ttlDuration = '7'
            this.form.ttlDurationTimeUnit = 'DAYS'
            this.form.timeout = '30'
            this.form.timeoutIsSuccess = true
            this.form.description = ''
            this.form.minchannel = 1
            this.form.minRestartVersion = 0
            this.showAdvancedFeatureMap = []
            this.form.failedRate = 0
            this.form.superEdit = false
            this.form.ordered = false
            this.form.consumerClientParamId = ''
            this.form.producerClientParamId = ''
            this.jobStores = []
            this.consumerClient.map(item => {
                if (item.defaultParam) {
                    this.form.consumerClientParamId = item.id
                }
            })
            this.producerClient.map(item => {
                if (item.defaultParam) {
                    this.form.producerClientParamId = item.id
                }
            })
            this.dialogFormVisible = true
        },
        showEditTopic (row) {
            getTopicById(row.id).then(response => {
                this.form.factor = response.factor
                if (response.consumerClientParams) {
                    this.form.consumerClientParamId = response.consumerClientParams.id
                } else {
                    this.form.consumerClientParamId = ''
                }
                if (response.producerClientParams) {
                    this.form.producerClientParamId = response.producerClientParams.id
                } else {
                    this.form.producerClientParamId = ''
                }
            })
            this.form.superEdit = false
            if (row.internal && this.role === 'SUPER_ADMIN') {
                this.form.superEdit = true
            }
            this.form.title = 'Edit Topic'
            this.form.id = row.id
            this.form.name = row.name
            this.form.owner = row.owner
            this.form.version = row.version
            this.form.restartVersion = row.restartVersion
            this.form.clientMapRetentionDay = row.clientMapRetentionDay
            this.form.channels = row.channels
            this.form.channelId = row.channelId
            this.form.channelName = row.channelName
            this.form.groupName = row.groupName
            this.form.jobStore = row.jobStore || null
            this.form.discardUnhandledTask = row.discardUnhandledTask
            this.form.disableFailover = row.disableFailover
            this.form.maxProduceRetryTimes = row.maxProduceRetryTimes
            this.form.produceRetryInterval = row.produceRetryInterval
            this.form.produceRetryIntervalTimeUnit = row.produceRetryIntervalTimeUnit
            this.form.produceLimit = row.produceLimit
            this.form.produceJobLimit = row.produceJobLimit
            this.form.ack = row.ack
            this.form.broadcast = row.broadcast
            this.form.threshold = row.threshold
            this.form.pollDurationMs = row.pollDurationMs
            this.form.publishIsPublic = row.publishIsPublic
            this.form.subscribeIsPublic = row.subscribeIsPublic
            this.form.enableMetrics = row.enableMetrics
            this.form.maxRetryTimes = row.maxRetryTimes
            this.form.retryIntervalTimeUnit = row.retryIntervalTimeUnit
            this.form.retryInterval = row.retryInterval
            this.form.ttlDuration = row.ttlDuration
            this.form.ttlDurationTimeUnit = row.ttlDurationTimeUnit
            this.form.timeout = row.timeout
            this.form.timeoutIsSuccess = row.timeoutIsSuccess
            this.form.description = row.description
            this.form.minchannel = row.channels
            this.form.minRestartVersion = row.restartVersion
            this.form.failedRate = row.failedRate
            this.showAdvancedFeatureMap = []
            this.form.ordered = row.ordered
            this.getDedicatedJob()
            getTopicConfig().then(response => {
                this.topicFactor = response.topicFactor
                this.advancedFeatureMap = response.advancedFeatureMap
                for (var item in this.advancedFeatureMap) {
                    if (row.advancedFeatureMap[item]) {
                        this.advancedFeatureMap[item].currentValue = row.advancedFeatureMap[item].currentValue
                    }
                    if (this.advancedFeatureMap[item].frontEndType === 0) {
                        const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                        if ((typeof suggestedValues) === 'string') {
                            this.advancedFeatureMap[item].suggestedValues = suggestedValues.substring(1, suggestedValues.length - 1).split(',')
                        }
                    }
                    if (this.advancedFeatureMap[item].frontEndType === 2) {
                        const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                        if ((typeof suggestedValues) === 'string') {
                            this.advancedFeatureMap[item].suggestedValues = JSON.parse(suggestedValues)
                        }
                    }
                }
            })
            this.dialogFormVisible = true
        },
        restartTopic (row) {
            this.$confirm('This will restart the topic. Continue?', 'Warning', {
                confirmButtonText: 'Restart',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                getTopicById(row.id).then(response => {
                    const factor = response.factor
                    if (response.consumerClientParams) {
                        this.form.consumerClientParamId = response.consumerClientParams.id
                    } else {
                        this.form.consumerClientParamId = ''
                    }
                    if (response.producerClientParams) {
                        this.form.producerClientParamId = response.producerClientParams.id
                    } else {
                        this.form.producerClientParamId = ''
                    }
                    var { id,
                        name,
                        advancedFeatureMap,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        channelId,
                        dcName,
                        groupName,
                        jobStore,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description } = row
                    restartVersion += 1
                    const data = { name,
                        advancedFeatureMap,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        factor,
                        channelId,
                        dcName,
                        groupName,
                        jobStore,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description }
                    updateTopic(id, data).then(response => {
                        this.paginationChange()
                        this.$message({
                            message: 'Edit topic success!',
                            type: 'success'
                        })
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Restart canceled'
                })
            })
        },
        showSubscriber (id) {
            this.loading = true
            getTopicRemain(id).then(response => {
                this.remainData = response
                this.remainVisible = true
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showPrivileges (id) {
            getUsers().then(response => {
                this.editPrivileges.users = response
            })
            getTopicPrivileges(id).then(response => {
                this.editPrivileges.topicId = response.topicId
                this.editPrivileges.publisherUserIds = response.publisherUserIds
                this.editPrivileges.subscriberUserIds = response.subscriberUserIds
            })
            this.editPrivileges.search = ''
            // this.editPrivileges.searchSubscribers = ''
            this.privilegesVisible = true
        },
        showBatchEditPrivilege () {
            getUsers().then(response => {
                this.editPrivileges.users = response
            })
            this.editPrivileges.topicId = ''
            this.editPrivileges.publisherUserIds = []
            this.editPrivileges.subscriberUserIds = []
            this.editPrivileges.search = ''
            // this.editPrivileges.searchSubscribers = ''
            this.privilegesVisible = true
        },
        batchDelete () {
            this.$confirm('This will delete the topics. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.batchLoading = true
                batchDelete({ topicIds: this.ids }).then(response => {
                    this.$message.success('Delete topics success!')
                    this.batchLoading = false
                    this.showSelect = false
                    this.ids = []
                }).catch(() => {
                    this.batchLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        save () {
            this.loading = true
            this.$refs.form.validate((valid) => {
                // for (var item in this.advancedFeatureMap) {
                //     const regex = this.advancedFeatureMap[item].regex
                //     if (!regex.test(this.advancedFeatureMap[item].currentValue)) {
                //         this.$message({
                //             message: this.advancedFeatureMap[item].display + ' is error',
                //             type: 'error'
                //         })
                //         return false
                //     }
                // }
                if (valid) {
                    this.loading = true
                    var { id,
                        name,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        factor,
                        channelId,
                        dcName,
                        groupName,
                        jobStore,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description } = this.form
                    var advancedFeatureMapStr = JSON.stringify(this.advancedFeatureMap)
                    var advancedFeatureMap = JSON.parse(advancedFeatureMapStr)
                    for (var item in advancedFeatureMap) {
                        let suggestedValues = JSON.stringify(advancedFeatureMap[item].suggestedValues)
                        // eslint-disable-next-line
                        advancedFeatureMap[item].suggestedValues = suggestedValues.replace(/(\")/g, '')
                    }
                    const data = { name,
                        advancedFeatureMap,
                        owner,
                        version,
                        restartVersion,
                        clientMapRetentionDay,
                        channels,
                        factor,
                        channelId,
                        dcName,
                        groupName,
                        jobStore,
                        discardUnhandledTask,
                        disableFailover,
                        maxProduceRetryTimes,
                        produceRetryInterval,
                        produceRetryIntervalTimeUnit,
                        produceLimit,
                        produceJobLimit,
                        ack,
                        broadcast,
                        threshold,
                        pollDurationMs,
                        publishIsPublic,
                        subscribeIsPublic,
                        enableMetrics,
                        maxRetryTimes,
                        retryIntervalTimeUnit,
                        retryInterval,
                        ttlDuration,
                        ttlDurationTimeUnit,
                        timeout,
                        timeoutIsSuccess,
                        failedRate,
                        ordered,
                        consumerClientParamId,
                        producerClientParamId,
                        description }
                    if (this.form.title === 'Create Topic') {
                        createTopic(data).then(response => {
                            this.select = 'name'
                            this.search = name
                            this.searchByName()
                            this.$message({
                                message: 'Create topic success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Edit Topic') {
                        updateTopic(id, data).then(response => {
                            this.paginationChange()
                            this.$message({
                                message: 'Edit topic success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Duplicate Topic') {
                        duplicateTopic(id, data).then(response => {
                            // this.pageable.page = 1
                            this.paginationChange()
                            this.$message({
                                message: 'Duplicate topic success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            message: 'error!',
                            type: 'error'
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        dropTopic (id) {
            this.$confirm('If the cluster which the topic belongs to is invalid, you can force to drop the topic. Continue?', 'Warning', {
                confirmButtonText: 'Drop',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                dropTopic(id).then(response => {
                    this.loading = false
                    this.paginationChange()
                    this.$message({
                        message: 'Drop topic success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Drop canceled'
                })
            })
        },
        showMonitor (name) {
            this.$router.push({
                path: '/dashboard/monitor',
                query: {
                    key: 'topicName',
                    value: name
                }
            })
        },
        showCreateSub (row) {
            this.subFormOrdered = row.ordered
            this.subForm.topicId = row.id
            this.subForm.dcName = ''
            this.subForm.group = ''
            this.subForm.minWorkingCount = 0
            this.subForm.settingConsumeDelayMs = -1
            this.subForm.threshold = 0
            this.subForm.shakeType = 'NoShake'
            this.subForm.shakeValidPeriodMs = 0
            this.subForm.consumerClientParamId = ''
            this.subForm.discardUnhandledTask = false
            this.subForm.timeout = 30
            this.subForm.timeoutIsSuccess = true
            this.subForm.maxRetryTimes = 3
            this.subForm.retryInterval = 1
            this.subForm.retryIntervalTimeUnit = 'MINUTES'
            this.subForm.version = ''
            this.subForm.createRealGroup = false
            this.subVisible = true
        },
        doCreateSub () {
            this.$refs.subForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    createSubscriber(this.subForm).then(response => {
                        this.$message.success('Add subscription ' + this.subForm.group + ' success')
                        this.loading = false
                        this.subVisible = false
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.$message.warning('Please check input')
                }
            })
        },
        showMigrate (row) {
            if (row.ids && row.ids.length > 0) {
                getTopicById(row.ids[0]).then(response => {
                    row.internal = response.internal
                    row.broadcast = response.broadcast
                    row.channelId = response.channelId
                    this.innerShowMigrate(row)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Get topic type error.'
                    })
                })
            } else {
                this.innerShowMigrate(row)
            }
        },
        innerShowMigrate (row) {
            this.groups = []
            this.migrateForm.isInternal = row.internal ? row.internal : false
            this.migrateForm.isBroadcast = row.broadcast ? row.broadcast : false
            this.migrateForm.oldDcName = row.dcName
            this.migrateForm.oldGroupName = row.groupName
            this.migrateForm.topicIds = row.ids ? row.ids : [row.id]
            this.migrateForm.dcName = ''
            this.migrateForm.groupName = ''
            this.migrateForm.forceMigrate = false
            this.migrateForm.subscriberRatioForOld = 20
            this.migrateForm.retainDataDays = 7
            if (row.internal) {
                getChannelById(row.channelId).then(response => {
                    this.migrateForm.isBroadcast = response.broadcast ? response.broadcast : this.migrateForm.isBroadcast
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Get channel broadcast type error.'
                    })
                })
            }
            this.migrateVisible = true
        },
        doMigrate () {
            const { isInternal, isBroadcast, dcName, groupName, topicIds, forceMigrate, subscriberRatioForOld, retainDataDays } = this.migrateForm
            const data = { isInternal, isBroadcast, dcName, groupName, topicIds, forceMigrate, subscriberRatioForOld, retainDataDays }
            this.migrateForm.loading = true
            migrateTopic(data).then(response => {
                this.$message.success('Submit migrate topic task success')
                this.migrateForm.loading = false
                this.migrateVisible = false
            }).catch(() => {
                this.migrateForm.loading = false
            })
        },
        deleteTopic (row) {
            this.$confirm('This will delete the topic. Continue?', 'Deleting ' + row.name, {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteTopic(row.id).then(response => {
                    this.loading = false
                    this.paginationChange()
                    this.$message({
                        message: 'Delete topic success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showInfo (row, expandedRows) {
            // this.checkInfo = true
            localStorage.setItem('topicId', row.id)
            // this.$router.push('/dashboard/topic/info')
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
            // return val.createdTime.split('T')[0] + ' ' + val.createdTime.split('T')[1].split('.')[0]
        },
        savePrivileges () {
            const { publisherUserIds, subscriberUserIds, topicId } = this.editPrivileges
            if (topicId) {
            const data = { publisherUserIds, subscriberUserIds, topicId }
            this.loading = true
            updateTopicPrivileges(topicId, data).then(response => {
                this.privilegesVisible = false
                this.loading = false
                this.$message({
                    message: 'Update privileges success!',
                    type: 'success'
                })
                this.paginationChange()
            }).catch(() => {
                this.loading = false
            })
            } else {
                const topicIds = this.ids
                const data = { publisherUserIds, subscriberUserIds, topicIds }
                this.batchLoading = true
                this.loading = true
                batchUpdateTopicPrivileges(data).then(response => {
                    this.showSelect = false
                    this.ids = []
                    this.privilegesVisible = false
                    this.batchLoading = false
                    this.$message({
                        message: 'Update privileges success!',
                        type: 'success'
                    })
                    this.paginationChange()
                }).catch(() => {
                    this.loading = false
                    this.batchLoading = false
                })
            }
        },
        showDuplicateTopic (row) {
            // this.fetchChannels()
            this.fetchDcs()
            this.fetchGroups()
            getTopicById(row.id).then(response => {
                this.form.consumerClientParamId = response.consumerClientParams.id
                this.form.producerClientParamId = response.producerClientParams.id
            })
            this.form.title = 'Duplicate Topic'
            this.form.id = row.id
            this.form.name = 'Copy_' + row.name
            this.form.owner = row.owner
            this.form.version = row.version
            this.form.restartVersion = row.restartVersion
            this.form.clientMapRetentionDay = row.clientMapRetentionDay
            this.form.channels = row.channels
            this.form.factor = row.factor
            this.form.dcName = ''
            this.form.groupName = ''
            this.form.jobStore = null
            this.form.channelId = ''
            this.form.discardUnhandledTask = row.discardUnhandledTask
            this.form.disableFailover = row.disableFailover
            this.form.maxProduceRetryTimes = row.maxProduceRetryTimes
            this.form.produceRetryInterval = row.produceRetryInterval
            this.form.produceRetryIntervalTimeUnit = row.produceRetryIntervalTimeUnit
            this.form.produceLimit = row.produceLimit
            this.form.produceJobLimit = row.produceJobLimit
            this.form.ack = row.ack
            this.form.broadcast = row.broadcast
            this.form.threshold = row.threshold
            this.form.pollDurationMs = row.pollDurationMs
            this.form.publishIsPublic = row.publishIsPublic
            this.form.subscribeIsPublic = row.subscribeIsPublic
            this.form.enableMetrics = row.enableMetrics
            this.form.maxRetryTimes = row.maxRetryTimes
            this.form.retryIntervalTimeUnit = row.retryIntervalTimeUnit
            this.form.retryInterval = row.retryInterval
            this.form.ttlDuration = row.ttlDuration
            this.form.ttlDurationTimeUnit = row.ttlDurationTimeUnit
            this.form.timeout = row.timeout
            this.form.timeoutIsSuccess = row.timeoutIsSuccess
            this.form.description = row.description
            this.form.failedRate = row.failedRate
            this.form.minchannel = 1
            this.form.minchannel = 0
            this.showAdvancedFeatureMap = []
            // this.advancedFeatureMap = row.advancedFeatureMap
            this.form.ordered = row.ordered
            // this.refreshTopicConfig()
            this.jobStores = []
            getTopicConfig().then(response => {
                this.topicFactor = response.topicFactor
                this.advancedFeatureMap = response.advancedFeatureMap
                for (var item in this.advancedFeatureMap) {
                    if (row.advancedFeatureMap[item]) {
                        this.advancedFeatureMap[item].currentValue = row.advancedFeatureMap[item].currentValue
                    }
                    if (this.advancedFeatureMap[item].frontEndType === 0) {
                        const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                        if ((typeof suggestedValues) === 'string') {
                            this.advancedFeatureMap[item].suggestedValues = suggestedValues.substring(1, suggestedValues.length - 1).split(',')
                        }
                    }
                    if (this.advancedFeatureMap[item].frontEndType === 2) {
                        const suggestedValues = this.advancedFeatureMap[item].suggestedValues
                        if ((typeof suggestedValues) === 'string') {
                            this.advancedFeatureMap[item].suggestedValues = JSON.parse(suggestedValues)
                        }
                    }
                }
            })
            this.dialogFormVisible = true
        },
        handleOPCommand (command) {
            if (command === 'cleanInternalTopic') {
                this.cleanInternalTopic()
            } else if (command === 'updateOldTopicsFailedRate') {
                this.updateOldTopicsFailedRate()
            } else if (command === 'updateTopicsMinInSyncReplica') {
                this.showUpdateTopicsMinInSyncReplica()
            } else if (command === 'updateOldTopicsProducerClientParam') {
                this.updateOldTopicsProducerClientParam()
            } else if (command === 'showUpdateTopicForOldSubscribers') {
                this.showUpdateTopicForOldSubscribers()
            } else if (command === 'updateOldTopicsRetention') {
                this.updateOldTopicsRetention()
            }
        },
        handleBatchCommand (command) {
            if (command === 'batch') {
                this.$refs.batchCreate.visible = true
            } else if (command === 'showSelect') {
                this.showSelect = true
            } else if (command === 'showBatchEditPrivilege') {
                this.showBatchEditPrivilege()
            } else if (command === 'batchDelete') {
                this.batchDelete()
            } else if (command === 'batchMigrate') {
                this.showMigrate({ ids: this.ids })
            } else if (command === 'hideSelect') {
                this.showSelect = false
                this.ids = []
            } else if (command === 'import') {
                this.showImport()
            }
        },
        getAction () {
            return process.env.VUE_APP_API_URL + 'api/v1/topic/information/import'
        },
        onProgress () {
            this.batchLoading = true
        },
        handleCopy1 () {
            var input = document.getElementById('textCopy1')
            input.value = this.longTaskId
            this.$nextTick(() => {
                const copybtn = this.$refs.copy1
                this.clipboard = new Clipboard(copybtn)
                this.showId = false
            })
        },
        onSuccess (res, file) {
            this.$message.success('Upload file success')
            this.batchLoading = false
            if (res.body.length) {
                this.longTaskId = res.body
                this.showId = true
                this.$nextTick(() => {
                    var input = document.getElementById('textCopy1')
                    input.value = res.body
                    const copybtn = this.$refs.copy1
                    this.clipboard = new Clipboard(copybtn)
                })
            }
        },
        onError (err, file) {
            this.batchLoading = false
            var errMesasage = JSON.parse(err.message).message
            if (errMesasage.indexOf('Exception:') !== -1) {
                errMesasage = errMesasage.slice(errMesasage.indexOf('Exception:') + 10, errMesasage.length)
            }
            this.$message({
                type: 'error',
                message: errMesasage
            })
        },
        handleCreateCommand (command) {
            if (command === 'batch') {
                this.$refs.batchCreate.visible = true
            }
        },
        handleCommand (command) {
            if (command.command === 'showPrivileges') {
                this.showPrivileges(command.param)
            } else if (command.command === 'showDuplicateTopic') {
                this.showDuplicateTopic(command.param)
            } else if (command.command === 'restartTopic') {
                this.restartTopic(command.param)
            } else if (command.command === 'deleteTopic') {
                this.deleteTopic(command.param)
            } else if (command.command === 'dropTopic') {
                this.dropTopic(command.param)
            } else if (command.command === 'showMonitor') {
                this.showMonitor(command.param)
            } else if (command.command === 'showMigrate') {
                this.showMigrate(command.param)
            } else if (command.command === 'showCreateSub') {
                this.showCreateSub(command.param)
            }
        },
        downloadTopics () {
            this.$confirm('This will download all topics. Continue?', 'Warning', {
                confirmButtonText: 'Download',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$message.info('Downloading, please wait..')
                downloadTopics().then((res) => {
                    let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                    var a = document.createElement('a')
                    a.href = URL.createObjectURL(blob)
                    a.download = 'topics_data.xlsx'
                    a.style.display = 'none'
                    document.body.appendChild(a)
                    a.click()
                    a.remove()
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Download canceled'
                })
            })
        },
        handleSelectionChange (val) {
            this.ids = []
            val.map(item => {
                this.ids.push(item.id)
            })
        }
    }
}
</script>
<style scoped>
.channel-select {
    float: right;
    margin: 10px;
    width: 20%;
}
.user-privilege {
    display: inline-block;
    text-align: center;
    width: 100%;
}
.search-app-input {
    width: 80%;
    margin: 0 10px;
}
</style>
<style>
.zm-dropdown .zm-button-group .zm-button {
    height: 32px;
    line-height: 12px;
    padding: 7px 16px;
}
.zm-dropdown .zm-button-group .zm-button--primary:last-child {
    padding: 7px;
}
.zm-dropdown-menu__item {
    font-size: 14px;
    line-height: 32px;
}
.zm-checkbox {
    margin-left: 5px;
}
.btn-in-line{
    margin: 10px
}
.zm-input-group{
    width: 20%;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.search-select {
    float: right;
    margin: 10px 0;
    width: 100px;
}
.zm-input-number {
    width: 200px;
}
.zm-radio {
    font-size: 18px;
}
.user-list {
    height: 40vh;
    overflow-y: auto;
    margin: 22px 10px 0 0;
}
.app-list {
    height: 40vh;
    overflow-y: auto;
    margin: 10px 10px 0 10px;
}
.number-with-select .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.select-with-number {
    width: 110px;
}
.select-with-number .zm-select-input {
    border-radius: 0 8px 8px 0;
}
.select-with-number.zm-select {
    border-radius: 0 8px 8px 0;
}
.tag-with-number {
    width: 110px;
    border-radius: 0 8px 8px 0;
}
.inactive-user {
    background-color: #fce9e9;
}
.active-user {
    background-color: #e0fbd39e;
}
.advanced-label {
    margin-right: 5px;
}
.short-dialog .zm-dialog__body {
    max-height: 50vh;
    overflow-y: scroll;
}
.short-dialog {
    margin: 0 auto;
}
</style>
